module.exports = __webpack_public_path__ + "img/PcContent3.576d2311.png";